export const getSponsorActive = ({ analysisActive, active, clientRemoved }) =>
    analysisActive && active && !clientRemoved;

export const getPlacementActive = ({ active, clientRemoved }) =>
    active && !clientRemoved;

export const getRspActive = ({ active, clientRemoved }) =>
    active && !clientRemoved;

export const getSponsorActiveAtPlacement = ({ active, clientRemoved }) =>
    active && !clientRemoved;
